import React from "react";
import styled from "styled-components";

const Bubble = styled.div`
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.textColor};
  padding: 2rem;
  border-radius: 20px;
  position: relative;
  transition: 300ms;

  &:after {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    right: ${(props) => (props.arrow === "right" ? 0 : "")};
    left: ${(props) => (props.arrow === "left" ? 0 : "")};
    border-top: 40px solid;
    border-bottom: 40px solid;
    border-top-color: transparent;
    border-bottom-color: transparent;
    border-left: ${(props) => props.arrow === "left" && "40px solid"};
    border-right: ${(props) => props.arrow === "right" && "40px solid"};
    border-left-color: ${(props) => props.backgroundColor};
    border-right-color: ${(props) => props.backgroundColor};
    display: block;
    bottom: -35px;
    z-index: -1;
    pointer-event: none;
  }

  &:hover {
    filter: brightness(115%);
  }
`;

const BubbleTalk = ({ backgroundColor = "#97459a", textColor = "#fff", arrow = "right", children }) => {
  return (
    <Bubble backgroundColor={backgroundColor} textColor={textColor} arrow={arrow} className="bubble-talk">
      {children}
    </Bubble>
  );
};

export default BubbleTalk;
